<h1 class="flashing-text">Connect, Care, and Expand—Invite a Fellow Doctor</h1>

<h2>Share your referral code & get complementary 1000 Rupees prize*</h2>

<div *ngIf="isLoggedIn">
  <div class="referral-code-container">
    <div>
      <h3>Your Referral Code:</h3>
    </div>
    <div class="code-container">
      <div class="referral-code">{{referralCode}}</div>
    </div>
  </div>
</div>

<h5>*Get complementary 1000 Rupees prize when referred user registers & purchase their first subscription</h5>